import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import DescriptionIcon from '@mui/icons-material/Description';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import Box from '@mui/material/Box';
import TableRow from '@mui/material/TableRow';
import Table from 'components/Table';
import TableCell from 'components/TableCell';
import FabDialog from 'components/FabDialog';
import Sorting, { useSorting } from 'components/Sorting';
import PagesListRow from 'components/PagesListRow';
import PagesListAdd from 'components/PagesListAdd';

import { PagesList_data$key } from '__generated__/PagesList_data.graphql';
import { useDelete } from 'lib';

type Props = {
  data: PagesList_data$key;
};

const PagesList: FC<Props> = props => {
  const { pages } = useFragment(
    graphql`
      fragment PagesList_data on Query {
        pages(first: 2147483647) {
          __id
          edges {
            node {
              id

              ...PagesListRow_page
            }
          }

          pageInfo {
            ...Table_pageInfo
          }
        }
      }
    `,
    props.data
  );

  const connectionID = pages?.__id;

  const [deletePage, deleting] = useDelete(connectionID);

  const [sort, sorting] = useSorting(
    graphql`
      mutation PagesListSortMutation($positions: [EntityWithPositionInput!]!) {
        updatePagePositions(positions: $positions)
      }
    `,
    connectionID
  );

  const { edges, pageInfo } = pages ?? {};

  if (!edges) return null;

  return (
    <Box>
      <Sorting edges={edges} onSort={sort}>
        <Table
          pageInfo={pageInfo ?? null}
          loading={sorting || deleting}
          icon={<DescriptionIcon />}
          head={
            <TableRow>
              <TableCell sx={{ width: '10px' }} />
              <TableCell>Pavadimas</TableCell>
              <TableCell />
            </TableRow>
          }>
          {edges?.map(({ node }) => (
            <PagesListRow
              sortDisabled={sorting}
              page={node}
              key={node.id}
              onDelete={deletePage}
            />
          ))}
        </Table>
      </Sorting>

      {connectionID && (
        <FabDialog fullWidth maxWidth="sm" icon={<NoteAddIcon />}>
          <PagesListAdd connectionID={connectionID} />
        </FabDialog>
      )}
    </Box>
  );
};

export default PagesList;
